import types from "../actionTypes";

export default (
  state = {
    managersDetails: undefined,
    lastLoginDetails: undefined,
    companyServices: undefined
  },
  action
) => {
  switch (action.type) {
    case types.SET_MANAGER_DETAILS:
      return Object.assign({}, state, {
        managersDetails: action.managersDetails,
      });
    case types.SET_LASTLOGIN_DETAILS:
      return Object.assign({}, state, {
        lastLoginDetails: action.lastLoginDetails,
      });
    case types.SET_USER_COMPANY_SERVICES:
      return Object.assign({}, state, {
        companyServices: action.companyServices,
      });
    default:
      return state;
  }
};
